// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/no-unknown-property */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/exports-last */
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { jsx } from 'theme-ui'
import { Button, Flex, Heading } from './elements'

export const TrapaZoid = ({ ...props }) => (
  <svg viewBox="0 0 140 38.2" {...props}>
    <path d="M14 1C55.1 1 96.2 1 137.3.9c3.2 0 3.8.8 3.8 3.9-.2 10.1-.2 20.3 0 30.4 0 2.3-.4 2.8-2.8 2.8-45.1 0-90.2 0-135.3-.1-.6 0-2.1 1-2-.9 4.5-12 9.3-23.8 13-36z" />
  </svg>
)
export const TrapazoidButton = ({ ...props }) => (
  <Flex
    sx={{
      position: 'relative',
      background: 'transparent',
      width: 142,
      height: 37.2,
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <TrapaZoid
      sx={{
        position: 'absolute',
        width: '100%',
      }}
    />
    <p sx={{ zIndex: 3, color: 'white' }}>{props.text}</p>
  </Flex>
)

const BrokenBorderBG = ({ fill, ...props }) => (
  <svg
    viewBox="0 0 325 75"
    preserveAspectRatio="none"
    fill="none"
    sx={{
      '.filled': {
        fill,
      },
    }}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.174 10.176h305.652v55.643H10.173V10.176z"
      className="filled"
    />
    <mask id="a" fill="#fff">
      <path fillRule="evenodd" clipRule="evenodd" d="M276.4 71.998H322v-68H4v68h241.2" />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M276.4 71.998H322v-68H4v68h241.2"
      fill="#000"
      fillOpacity={0.01}
    />
    <path
      d="M322 71.998v2h2v-2h-2zm0-68h2v-2h-2v2zm-318 0v-2H2v2h2zm0 68H2v2h2v-2zm272.4 2H322v-2-2h-.003H276.4v4zm47.6-2v-68h-4v68h4zm-2-70H4v4h318v-4zm-320 2v68h4v-68H2zm2 68c0 2 0 2 .002 2H245.2v-4H4.002c-.002 0-.002 0-.002 2z"
      className="filled"
      mask="url(#a)"
    />
  </svg>
)

export const BorderButton = ({
  color = 'white',
  textColor = 'primary',
  fontSize = [[2, 3]],
  ...props
}) => {
  return (
    <Button
      color={textColor}
      display="flex"
      borderRadius={0}
      sx={{
        position: 'relative',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'transparent',
        py: [3],
        px: 4,
      }}
      name="Contact"
      id="contact"
      {...props}
    >
      <BrokenBorderBG
        fill={color}
        sx={{
          position: 'absolute',
          height: '100%',
          width: '100%',
          top: 0,
          left: 0,
          zIndex: -1,
        }}
      />
      <Heading
        fontSize={fontSize}
        my={0}
        sx={{ zIndex: 4, color: textColor, verticalAlign: 'center' }}
      >
        {props.text || `Get Started`}
      </Heading>
    </Button>
  )
}
